export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

var base64js = require('base64-js');
export const Base64Encode = function(str, encoding = 'utf-8') {
  var bytes = new (TextEncoder || TextEncoderLite)(encoding).encode(str);        
  return base64js.fromByteArray(bytes);
}

export const Base64Decode = function(str, encoding = 'utf-8') {
  var bytes = base64js.toByteArray(str);
  return new (TextDecoder || TextDecoderLite)(encoding).decode(bytes);
}


export const loadDeviceInfo = function() {
  const info = {
    "userAgent" : window.navigator.userAgent,
    "vendor" : window.navigator.vendor,
    "appName" : window.navigator.appName,
    "oscpu" : window.navigator.oscpu,
    "cpuClass" : window.navigator.cpuClass
  }
  
  // console.log(info);

  return JSON.stringify(info);
}

export const makeBasicHeader = function(clientId, clientSecret) {
  const plainHeader = clientId + ":" + clientSecret;
  const header = Base64Encode(plainHeader);
  // console.log(plainHeader + " => " + header);
  return "Basic " + header;
}


export const toggleBodyClass = function(addRemoveClass, className) {
  const el = document.body;

  if (addRemoveClass === 'addClass') {
    el.classList.add(className);
  } else {
    el.classList.remove(className);
  }
}
